import React from 'react';
import { Grid, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const CampaignPendingUI = () => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ marginTop: '50px' }}
    >
      <Grid item xs={12} md={6} lg={4} style={{ textAlign: 'center' }}>
        <Typography variant="h5" color="textSecondary" gutterBottom>
          <WarningIcon color="warning" style={{ fontSize: 40, marginBottom: '-10px' }} />
        </Typography>
        <Typography variant="h5" color="textSecondary">
          Waiting for Campaign Approval
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Please contact admin for assistance.
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CampaignPendingUI;